import { IMaskMixin } from 'react-imask'

import { Input } from 'components/Input'

export const MaskInput = IMaskMixin(({ inputRef, errors, touched, ...props }: TSFixMe): TSFixMe => {
  return <Input ref={inputRef} errors={errors} touched={touched} {...props} />
})
